import { z } from 'zod'
import { bookingStatusSchema } from './hotel-booking'
const amount = z.object({
  currency: z.literal('CNY'),
  amount_minor: z.number().int().positive().safe(),
})
const localTime = z.object({ local_datetime: z.string(), timezone: z.string() })
export const flightSourceSchema = z.object({
  domain: z.literal('FLIGHT'),
  role: z.string(),
  travelers: z.object({
    adults: z.number().int().min(1),
    children: z.number().int().nonnegative(),
    infants: z.number().int().nonnegative(),
  }),
  from: z.object({ name: z.string() }),
  to: z.object({ name: z.string() }),
  journeys: z
    .array(
      z.object({
        segments: z
          .array(
            z.object({
              departure_code: z.string(),
              arrival_code: z.string(),
              departure: localTime,
              arrival: localTime,
              marketing_airline_code: z.string(),
              marketing_flight_number: z.string(),
            }),
          )
          .min(1),
      }),
    )
    .min(1),
})
export const flightBookingSessionSchema = z.object({
  schema_version: z.literal('booking_session_v1'),
  booking_session_id: z.string().min(1),
  session_revision: z.number().int().nonnegative(),
  status: bookingStatusSchema,
  order_no: z.string().nullable(),
  domain: z.literal('FLIGHT'),
  source: z.object({
    planner_id: z.string(),
    version_id: z.string(),
    module_id: z.string(),
    revision: z.number().int(),
  }),
  source_snapshot: flightSourceSchema,
  created_at: z.iso.datetime(),
  expires_at: z.iso.datetime(),
})
export const flightGuestFormSchema = z
  .object({
    traveler_ids: z
      .array(z.string().regex(/^trv_[A-Za-z0-9_-]{1,60}$/))
      .min(1)
      .max(9),
    contact_name: z.string().trim().min(1).max(64),
    contact_mobile: z
      .string()
      .trim()
      .regex(/^\+?[0-9][0-9 -]{4,30}$/),
  })
  .refine((f) => new Set(f.traveler_ids).size === f.traveler_ids.length, '不能重复选择旅客')
export const flightCheckoutSchema = z
  .object({
    schema_version: z.literal('flight_checkout_v1'),
    booking_session_id: z.string(),
    session_revision: z.number().int().nonnegative(),
    status: bookingStatusSchema,
    order_no: z.string().nullable(),
    local_only: z.literal(true),
    source_snapshot: flightSourceSchema,
    form: flightGuestFormSchema.nullable(),
    confirmation_id: z.string().nullable(),
    confirmation_valid_until: z.iso.datetime().nullable(),
    confirmation_total: amount.nullable(),
    candidates: z.array(
      z.object({
        candidate_ref: z.string(),
        cabin_name: z.string(),
        cabin_code: z.string(),
        expires_at: z.iso.datetime(),
        selected: z.boolean(),
        total: amount,
        ticket_rules: z.array(z.string()),
        baggage_rules: z.array(z.string()),
      }),
    ),
  })
  .refine(
    (c) => c.status !== 'ORDER_CREATED' || !!c.order_no,
    'Created order requires order number',
  )
export type FlightCheckout = z.infer<typeof flightCheckoutSchema>
export type FlightGuestForm = z.infer<typeof flightGuestFormSchema>
export type FlightBookingSession = z.infer<typeof flightBookingSessionSchema>
